import { render, staticRenderFns } from "./uploadNew.vue?vue&type=template&id=0fbd4033&scoped=true"
import script from "./uploadNew.vue?vue&type=script&lang=js"
export * from "./uploadNew.vue?vue&type=script&lang=js"
import style1 from "./uploadNew.vue?vue&type=style&index=1&id=0fbd4033&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbd4033",
  null
  
)

export default component.exports